import React from "react";
export default class SVG extends React.Component {
  render() {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18.12 18.12" {...this.props}><path fill="none" stroke="currentColor" strokeMiterlimit="10" strokeWidth="3" d="M1.06 17.06l16-16m0 16l-16-16" /></svg>;
  }

}


// WEBPACK FOOTER //
// ./src/icons/close.inline.svg